import { render, staticRenderFns } from "./MapBookmarks.vue?vue&type=template&id=1dd790b1&scoped=true&"
import script from "./MapBookmarks.vue?vue&type=script&lang=js&"
export * from "./MapBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./MapBookmarks.vue?vue&type=style&index=0&id=1dd790b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd790b1",
  null
  
)

export default component.exports